import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_GISFO_WORKORDER } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDGisfoWorkorderState extends EntityState<IID_GISFO_WORKORDER, ID> {}

@Injectable({
  providedIn: "root",
})
@PersistedStoreConfig({ name: Topics.IID_GISFO_WORKORDER , realtimeEntity: 'IID_GisfoWorkorder'})
@InterfaceDataStore(InterfaceName.GISFO_WORKORDER)
export class IIDGisfoWorkorderStore extends EntityStore<IIDGisfoWorkorderState> {
  constructor() {
    super([]);
  }
}
